import { createPortal } from "react-dom"
import { useTranslation } from "react-i18next"

import { MessageSquare } from "@/components/icons"

import { type Lane } from "./schemas"

/**
 * Floating "Resume feedback" chip rendered when the feedback dialog has been
 * minimised. Portalled to `document.body` so it sits above the rest of the
 * app chrome. The label changes with the lane so the user knows which draft
 * they're returning to.
 */
export function ResumeChip({ lane, onResume }: { lane: Lane | undefined; onResume: () => void }) {
  const { t } = useTranslation()
  if (typeof document === "undefined") return null
  return createPortal(
    <button
      className="bg-background hover:bg-accent/40 focus:ring-ring fixed right-4 bottom-4 z-[80] inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm shadow-lg focus:ring-2 focus:ring-offset-2 focus:outline-none"
      type="button"
      onClick={onResume}
    >
      <MessageSquare className="size-4" />
      <span>
        {lane === "incident"
          ? t("feedback.dialog.resumeIncident", "Resume incident report")
          : t("feedback.dialog.resumeBug", "Resume bug report")}
      </span>
    </button>,
    document.body
  )
}
